export default __webpack_public_path__ + "static/media/Franchise_img.76d0d56b.jpg";